import { uid } from "../../helpers";
export function addTask({ store, task, reverse = false, }) {
    const newId = uid().toString();
    store.in.exec("add-task", {
        id: newId,
        targetId: task?.id,
        parent: task?.parent,
        project: store.getState()?.activeProject,
        reverse,
    });
    store.in.exec("select-task", { id: newId });
    store.in.exec("open-inline-editor", { id: newId, type: "task" });
}
//# sourceMappingURL=add.js.map